import React from "react";
import {Helmet} from "react-helmet";
// import {injectShopContainer} from '../../react/ShopDataContainer'


export default class Base extends React.Component {
  render () {
    // console.log('hi', shop)
    let name = "Pablitos Tacos"
    let description = "TJ-Peruvian Style Tacos, Quesadillas, Mulitas and Burritos. Order Delivery and Pickup here. Locations in Burbank, North Hollywood and more opening."
    return (
      <Helmet>
          <meta charSet="utf-8" />
          <title>{name}</title>
          <meta name="description"
            content={description} />
          <link rel="canonical" href="https://pablitostacos.com" />

          <link rel="manifest" href={`${process.env.PUBLIC_URL}/pablitostacos.json`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/pablitostacos.png`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/pablitostacos.png`} />
          <link rel="shortcut icon"
            href={`${process.env.PUBLIC_URL}/pablitostacos.png`}
          />

          {/* Open Graph */}
          <meta property="og:title" content={name} />
          <meta property="og:site_name" content={name} />
          <meta property="og:description" content={description} />
          {/* <meta property="og:image" content={} /> */}
          {/* <meta property="og:url" content="http://euro-travel-example.com/index.htm" /> */}
      </Helmet>


    );
  }
};

// export default injectShopContainer(Base)
